import { TextField } from "@material-ui/core";
import { CSSProperties, ReactNode } from "react";

interface RxTextFieldProps {
	fullwidth?: boolean;
	id?: string;
	name?: string;
	label?: string;
	placeholder?: string;
	value?: string | number;
	required?: boolean;
	style?: CSSProperties;
	multiline?: boolean;
	minRow?: number;
	maxRow?: number;
	onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	onBlur?: any;
	variant?: "standard" | "filled" | "outlined";
	size?: "small" | "medium";
	ref?: any;
	error?: boolean;
	helperText?: string | false;
	type?: string;
	helperTextStyle?: string;
	inputLabelStyle?: CSSProperties;
	inputLabelClassName?: string;
	inputStyle?: CSSProperties;
	inputClassName?: string;
	inputStartAdornment?: ReactNode;
	inputEndAdornment?: ReactNode;
	disabled?: boolean;
}

const RxTextField = (props: RxTextFieldProps) => {
	return (
		<TextField
			ref={props.ref}
			fullWidth={props.fullwidth}
			label={props.label}
			id={props.id}
			name={props.name}
			placeholder={props.placeholder}
			value={props.value}
			required={props.required}
			style={props.style}
			onChange={props.onChange}
			onBlur={props.onBlur}
			multiline={props.multiline}
			minRows={props.minRow}
			maxRows={props.maxRow}
			variant={props.variant}
			size={props.size}
			error={props.error}
			helperText={props.helperText}
			type={props.type}
			disabled={props.disabled}
			InputLabelProps={{
				style: props.inputLabelStyle,
				className: props.inputLabelClassName,
			}}
			InputProps={{
				startAdornment: props.inputStartAdornment,
				endAdornment: props.inputEndAdornment,
			}}
			inputProps={{
				style: props.inputStyle,
				className: props.inputClassName,
			}}
			FormHelperTextProps={{
				classes: {
					root: props.helperTextStyle,
				},
			}}
		/>
	);
};

export default RxTextField;
